import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { FlashService } from '@app/services/flash.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { FollowIdComponent } from "@app/modules/supplier-portal/components/followId-confirmation/followId-confirmation.component";
import { ObservationModal } from "@app/modules/supplier-portal/components/observation-modal/observation-modal.component";
import { UploadDiscrepanciesModal } from "@app/modules/supplier-portal/components/upload-discrepancies-modal/upload-discrepancies-modal.component";

@Component({
  selector: "app-enrich-discrepancies-table",
  templateUrl: "./enrich-discrepancies-table.component.html",
  styleUrls: ["./enrich-discrepancies-table.component.css"]
})

export class EnrichDiscrepanciesTable implements OnInit {
  constructor(
    private flash: FlashService,
    private modal: NgbModal,
  ) {}

  @ViewChild('fileInput')
  inputEl: ElementRef;

  @Input()
  me: any;

  @Input()
  Proformas: any;

  @Input()
  discrepancies: any;

  @Input()
  files: any

  @Input()
  followId: any;

  @Output()
  changeFilterData = new EventEmitter();

  @Output()
  downloadDiscrepancies = new EventEmitter();

  @Output()
  downloadDiscrepanciesSupplier = new EventEmitter();

  @Output()
  fileInputChanges = new EventEmitter()

  @Output()
  uploadSupplierDiscrepancies = new EventEmitter()

  @Output()
  downloadFiles = new EventEmitter()

  @Output()
  supplierFiles = new EventEmitter()

  @Output()
  changeFollowIds = new EventEmitter()

  currentPage = 1;
  pages: number = 1;
  currentPMSelected = ""
  currentOriginSelected = "";
  currentSupplierSelected = "";
  currentFollowSelected = "";
  currentN2Selected = "";
  FollowIds = [];
  currentProviderId = null;
  isShowSupplier = false;
  currentIndexSupplier = null;
  currentSupplier = []
  allPMDiscre = []
  allSuppliersOrigins = []
  currentDiscrepancies = []
  _modalRef = null;
  _modalObservation = null;

  get isMerchant(){
    return this.me && this.me.role === "merchant"
  }

  get isPM(){
    return this.me && this.me.role === "product-manager"
  }

  get isSupplier(){
    return this.me && this.me.role === "supplier"
  }

  get show(){
    return this.me && (this.me.role === 'product-manager' || this.me.role === 'merchant')  
  }

  ngOnInit() {
    this.discrepancies.forEach((d) => {
      this.currentDiscrepancies.push(d)
      d.proformas.forEach((p) => {
        if(p.Buyer && (this.allPMDiscre.length === 0 || !this.allPMDiscre.map((a) => a.id).includes(p.Buyer.id))){
          this.allPMDiscre.push(p.Buyer)
        }
      })
      d.suppliers.forEach((e) => {
        if(!this.allSuppliersOrigins.map((a) => a.id).includes(e.origin.id)){
          this.allSuppliersOrigins.push(e.origin)
        }
      })  
    });
  }

  changeFilterDiscre(e, type){
    if(type === "PM"){
      this.currentPMSelected = e.target.value
    }
    if(type === "Origin"){
      this.currentOriginSelected = e.target.value
      if(e.target.value !== ""){
        this.currentSupplier = this.currentSupplier.filter((c) => c.CountryId !== e.target.value)
      }
    }
    
  }

  changeFilter(e, type){
    if(type === "supplier"){
      this.currentSupplierSelected = e.target.value
    }else if(type === "Follow"){
      this.currentFollowSelected = e.target.value
    }else{
      this.currentN2Selected = e.target.value
    }
    this.changeFilterData.emit({e, type})
  }

  download(e){
    if(this.me && this.me.role === "supplier"){
      this.downloadDiscrepancies.emit(e)
    }else{
      let message = ""
      if(this.me && this.me.role === 'merchant' && this.currentPMSelected === ""){
        message = "Debe seleccionar PM!\n"
      }
      if(this.currentOriginSelected === ""){
        message = message === "" ? "Debe seleccionar Origen!" : message + "Debe seleccionar Origen!"
      }
      if(message !== ""){
        this.flash.emit({ type: 'warning', message: message });
      }else{
        this.downloadDiscrepancies.emit(
        { e: e, currentPMSelected: this.currentPMSelected ,
          currentOriginSelected: this.currentOriginSelected, 
        })
      }
    }
  }

  downloadSuppplier(e, sup){
     let message = ""
     if(this.me && this.me.role === 'merchant' && this.currentPMSelected === ""){
      message = "Debe seleccionar PM!\n"
      }
      if(this.currentOriginSelected === ""){
        message = message === "" ? "Debe seleccionar Origen!" : message + "Debe seleccionar Origen!"
      }

      if(message !== ""){
        this.flash.emit({ type: 'warning', message: message });
      }else{
        this.downloadDiscrepanciesSupplier.emit({ 
          e: e, sup: sup, 
          currentPMSelected: this.currentPMSelected,
          currentOriginSelected: this.currentOriginSelected
        })
      }
  }

  changeFileInput(e, ed, sup?) {
    if (e.target.files) {
      const files = e.target.files;

      if (files && files[0]) {
        if(this.me && this.me.role === "supplier"){
          this.uploadSupplierDiscrepancies.emit({ 
            files: files[0], 
            type: 'supplierDiscrepancies',
            ed
          })
        }else{
          let message = ""
          if(this.me && this.me.role === 'merchant' && this.currentPMSelected === ""){
            message = "Debe seleccionar PM!\n"
          }
          if(this.currentOriginSelected === ""){
            message = message === "" ? "Debe seleccionar Origen!" : message + "Debe seleccionar Origen!"
          }
          if(message !== ""){
            this.flash.emit({ type: 'warning', message: message });
          }else{
            this.uploadSupplierDiscrepancies.emit({
              files: files[0], 
              type: 'supplierDiscrepancies', 
              ed,
              sup,
              currentPMSelected: this.currentPMSelected,
              currentOriginSelected: this.currentOriginSelected
            })
          }
        }
       
      }

      e.target.value = null;
    }
  }

  fileInputChange(e){
    this.fileInputChanges.emit(e)
  }

  PZQuantity(e){
    return e.proformas.length
  }

  totalFob(e){
    let total = 0
    e.proformas.forEach((proforma) => {
      if(proforma.type === 'ALTELECTRO'){
      }else{
        const fobType = proforma.type === 'VESTUARIO' ? 'finalFOB' : 
        proforma.fobType === null ? 'closedFob' : proforma.fobType
        const totalSum = proforma.ProductCountryShipments.reduce((sum, item) => {
          let fob;
          if(item.extraCost > 0){
            fob = parseFloat(`${item.extraCost}`).toFixed(2)
          }else if(item.weightedFob > 0 && parseFloat(item.weightedFob) > 0){
            fob = parseFloat(item.weightedFob)
          }else if(item.fob > 0 && proforma.fobType === 'customFOB'){
            fob = parseFloat(item.fob)
          }else if(item.fobType !== null && proforma.fobType !== "customFOB" && item.fobType === fobType){
            fob = parseFloat(item.ProductCountry.Product.metadata[item.fobType])
          }else{
            fob = parseFloat(item.ProductCountry.Product.metadata[fobType])
          }
          if(!fob || fob < 0){
            fob = 0
          }
          return sum += (fob*item.units)
        }, 0)
        total += totalSum
      }
    });
    return total
  }

  showSupplier(dis, index){
    if(dis && this.currentProviderId !== dis.id){
      this.currentProviderId = dis.id
      this.isShowSupplier = true
      this.currentIndexSupplier = index
      this.currentSupplier = dis.suppliers
    }else{
      this.currentProviderId = null
      this.isShowSupplier = false
      this.currentIndexSupplier = null
      this.currentSupplier = []
    }
  }

  hasFiles(SupplierId){
    const currentSupplierFile = this.files.find((f) => f.metadata["supplierId"] === SupplierId)
    return currentSupplierFile && currentSupplierFile.metadata && 
    currentSupplierFile.metadata.supplierStatus && 
    (currentSupplierFile.metadata.supplierStatus === 1 ||
    currentSupplierFile.metadata.supplierStatus === 2 ||
    currentSupplierFile.metadata.supplierStatus === 3) ? true : false
  }

  statusFile(SupplierId){
    const currentSupplier = this.files.find((f) => f.metadata["supplierId"] === SupplierId)
    return currentSupplier && currentSupplier.metadata && 
    currentSupplier.metadata.supplierStatus ? 
    currentSupplier.metadata.supplierStatus : 4
  }

  fileMessage(SupplierId){
    const currentSupplier = this.files.find((f) => f.metadata["supplierId"] === SupplierId)
    return `Último archivo subido por ${currentSupplier.metadata.typeUser === "supplier" ? 'Supplier' : 'Merchant'}`
  }

  downloadFile(sup){
    const currentFiles = this.files.find((f) => f.metadata["supplierId"] === sup.id)
    const fileName = `Discrepancia - ${sup.name}`
    this.downloadFiles.emit({currentFiles: currentFiles.filePath, fileName })
  }

  supplierFile(ed, sup, status){
    const currentFiles = this.files.find((f) => f.metadata["supplierId"] === sup.id)
    this.supplierFiles.emit({ currentFilesId: currentFiles.id, status: status, type: ed.type })
  }

  uploadModal(ed, sup){
    let canUpload = true
    if(this.me && this.me.role !== "supplier"){
      let message = ""
      if(this.me && this.me.role === 'merchant' && this.currentPMSelected === ""){
        message = "Debe seleccionar PM!\n"
      }
      if(this.currentOriginSelected === ""){
        message = message === "" ? "Debe seleccionar Origen!" : message + "Debe seleccionar Origen!"
      }

      if(message !== ""){
        canUpload = false
        this.flash.emit({ type: 'warning', message: message });
      }
    }
    if(canUpload){
      this._modalRef = this.modal.open(UploadDiscrepanciesModal, {
        backdrop : 'static',
        keyboard : false
      });
      this._modalRef.componentInstance.me = this.me;
      this._modalRef.result.then(
        result => {
          // do nothing
        },
        res => {
          if(res){
            if(this.me && this.me.role === "supplier"){
              this.uploadSupplierDiscrepancies.emit({ 
                files: res.file, 
                type: 'supplierDiscrepancies',
                observation: res.observation,
                ed
              })
            }else{
              this.uploadSupplierDiscrepancies.emit({
                files: res.file, 
                type: 'supplierDiscrepancies', 
                observation: res.observation,
                ed,
                sup,
                currentPMSelected: this.currentPMSelected,
                currentOriginSelected: this.currentOriginSelected
              })
            }
          }
        }
      )
      this._modalRef = null
    }
    
  }

  openSupplierModal(sup, ed){
    const currentFiles = this.files.find((f) => f.metadata["supplierId"] === sup.id)
    this._modalObservation = this.modal.open(ObservationModal, {
      backdrop : 'static',
      keyboard : false
    });
    this._modalObservation.componentInstance.data = currentFiles;
    this._modalObservation.result.then(
      result => {
        // do nothing
      },
      res => {
        if(res){
          if(res.type === 1){
            this.supplierFiles.emit({ currentFilesId: currentFiles.id, status: 'approved', type: ed.type })
          }else if(res.type === 2){
            this.supplierFiles.emit({ currentFilesId: currentFiles.id, status: 'decline', type: ed.type })
          }else{
            const fileName = `Discrepancia - ${sup.name}`
            this.downloadFiles.emit({currentFiles: currentFiles.filePath, fileName })
          }
        }
      }
    )
    this._modalObservation = null
  }

  messageAlert(){
    return this.isPM ? "Recuerde seleccionar Puerto para descargar discrepancia" : this.isMerchant ? 
    "Recuerda seleccionar PM y Puerto para descargar discrepancia" : ""
  }

  changeFollowId(){
    this._modalObservation = this.modal.open(FollowIdComponent, {
      backdrop : 'static',
      keyboard : false
    });
    this._modalObservation.result.then(
      result => {
        // do nothing
      },
      res => {
        if(res){
          this.changeFollowIds.emit(res)
        }
      }
    )
    this._modalObservation = null
  }

  canUpdate(ed){
    const typeUser = ed && ed.files && ed.files[0] && ed.files[0].metadata && 
    ed.files[0].metadata.typeUser && ed.files[0].metadata.typeUser || ""
    return typeUser === "supplier" || typeUser === "" ? false : true
  }
}